export default "__VITE_ASSET__DXLhz9xi__"